import { render } from "./FooterShape.vue?vue&type=template&id=3051fd5c&scoped=true"
const script = {}

import "./FooterShape.vue?vue&type=style&index=0&id=3051fd5c&scoped=true&lang=css"

import exportComponent from "/Users/ffavreau/www/canton-dans-le-bouillon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3051fd5c"]])

export default __exports__